import { Navigate, useRoutes } from 'react-router-dom';

import { authRoutes } from './auth';
import { mainRoutes } from './main';
import { adminRoutes } from './admin';
import { dashboardRoutes } from './dashboard';
// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: <Navigate to="/dashboard" replace />,
    },

    // Auth routes
    ...authRoutes,

    // Dashboard routes
    ...dashboardRoutes,

    // Admin routes
    ...adminRoutes,

    // Main routes
    ...mainRoutes,

    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
